// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__15ktW","boxTitle":"Qualiphy_boxTitle__29bkD","box":"Qualiphy_box__dE4ox","toggleWrap":"Qualiphy_toggleWrap__2W4zM"};